// extracted by mini-css-extract-plugin
export var fileUpload = "_fw-1";
export var modalButton = "_fw-0";